import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceLocationComponent } from './device-location.component';
import {MaterialModule} from '../../material.module';
import {FormsModule} from '@angular/forms';
import {LayoutModule} from "../../components/layout/layout.module";
import {ArmFormModule} from "../../components/arm-form/arm-form.module";
import {ArmFormTitleModule} from "../../components/arm-form/arm-form-title/arm-form-title.module";



@NgModule({
  declarations: [DeviceLocationComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    LayoutModule,
    ArmFormModule,
    ArmFormTitleModule
  ]
})
export class DeviceLocationModule { }
